<div class="product-selection-page">
    <div class="selected-vehicle-list">
        <div class="header">
            <div class="fold" (click)="toggleVehicleList()">
                <h3>{{activeTabIndex===0?'已选车型':'已选产品组'}}（{{ selectedVehicles.length }}）</h3>
                <i style="margin-left: 20px;" nz-icon [nzType]="showVehicleList ? 'up' : 'down'"></i>
            </div>
            <div class="actions">
                <button nz-button nzType="default" (click)="handleReselect()">
                    <i nz-icon nzType="close" nzTheme="outline"></i>
                    <span>重新选择</span>
                </button>
                <button nz-button nzType="primary" *ngIf="activeTabIndex===0" (click)="copyList()">复制</button>
            </div>
        </div>
        <ul *ngIf="showVehicleList">
            <li *ngFor="let vehicle of selectedVehicles" style="margin-top: 10px;">• {{ vehicle }}</li>
        </ul>
    </div>

    <div class="content">
        <div class="left">
            <h4 style="font-weight: 700; font-size: 22px;">请选择产品组</h4>
            <nz-spin [nzSpinning]="isGroupLoading" nzTip="加载中...">
                <div style=" height: 670px; overflow-y: auto;">
                    <div *ngFor="let group of filterMenu" style="border-bottom: 1px solid #E0E2E5;">
                        <div class="group-header" (click)="group.expanded = !group.expanded">
                            <label class="label-checkbox" nz-checkbox [(ngModel)]="group.checked"
                                (ngModelChange)="onGroupCheckChange(group)"
                                [nzIndeterminate]="handleIsChecked(group.subList)"
                                [nzDisabled]="!isDisabledCheckBoxAll(group.category1Name)">
                                <i nz-icon [nzType]="'filter'"></i>
                                {{ group.category1Name }}
                            </label>
                            <i nz-icon [nzType]="group.expanded ? 'up' : 'down'" class="ml-1"></i>
                        </div>

                        <div class="sub-group" *ngIf="group.expanded" style="margin-bottom: 8px; display: grid;">
                            <label class="label-checkbox" nz-checkbox *ngFor="let item of group.subList"
                                (ngModelChange)="onSubGroupCheckChange(group, item)"
                                [nzDisabled]="!isDisabledCheckBox(item.category2Name)" [(ngModel)]="item.checked">
                                {{ item.category2Name }}
                            </label>
                        </div>
                    </div>
                </div>
            </nz-spin>
            <!-- <button nz-button nzType="primary" class="mt-2" (click)="onSearch()" style="width: 220px;">搜索</button> -->
        </div>

        <div class="right">
            <nz-table [nzLoading]="isTableLoading" #basicTable [nzData]="partList" [nzPageSize]="pageSize"
                [nzShowPagination]="true" [nzFrontPagination]="false" [nzPageIndex]="pageIndex"
                (nzPageIndexChange)="onPageIndexChange($event)" nzShowSizeChanger
                (nzPageSizeChange)="onPageSizeChange($event)" [nzShowTotal]="totalTemplate"
                [nzTotal]="pageInfo.totalCounts"
                [nzWidthConfig]="widthConfigFunc()" [nzScroll]="{ x: '100%'}"
                nzTableLayout="fixed">
                <thead>
                    <tr>
                        <th>图片</th>
                        <th [nzSortFn]="sortTypeFormularFn" *ngIf="isIncluded()">别称</th>
                        <th [nzSortFn]="sortPartNoFn">物料号</th>
                        <th [nzSortFn]="sortPartNoStatusFn">状态</th>
                        <th [nzSortFn]="sortPartNameFn" *ngIf="activeTabIndex === 0">名称/匹配名称</th>
                        <th [nzSortFn]="sortPartNameFn" *ngIf="activeTabIndex === 1">名称</th>
                        <th [nzSortFn]="sortCarsModelYearListFn" *ngIf="activeTabIndex === 0">年款</th>
                        <th *ngIf="selectedCategory1Name.has('雨刮')">尺寸</th>
                        <th *ngIf="activeTabIndex === 0">备注</th>
                        <!-- <th [nzRight]="'0px'">操作</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of basicTable.data">
                        <td><img [src]="getImage(item.imageList)" alt="图" width="40" /></td>
                        <td *ngIf="isIncluded()"><a style="width: 50px; display: inline-block;">{{ item.typeFormular
                                }}</a><i *ngIf="item.typeFormular" nz-icon nzType="copy"
                                (click)="onCopyPartNumber(item.typeFormular)"
                                style="cursor: pointer; color: #007BC0;"></i></td>
                        <td><a (click)="goDetail(item.partId)" style="color: #007BC0;">{{ item.partNo }}</a><i nz-icon
                                nzType="copy" (click)="onCopyPartNumber(item.partNo)"
                                style="cursor: pointer; margin-left: 5px; color: #007BC0;"></i></td>
                        <td>
                            <nz-tag [ngClass]="item.partNoStatus === '在售' ? 'in-sale' : 'shutdown'">{{
                                item.partNoStatus
                                }}</nz-tag>
                        </td>
                        <td *ngIf="activeTabIndex === 0">
                            <div>
                                <p>{{ item.partName }}</p>
                                <p *ngFor="let appDes of item.appDesList">
                                    {{ appDes }}
                                </p>
                            </div>
                        </td>
                        <td *ngIf="activeTabIndex === 1">
                            <div>
                                <p>{{ item.partName }}</p>
                            </div>
                        </td>
                        <td *ngIf="activeTabIndex === 0">{{ item.carsModelYearList ? item.carsModelYearList.join(', ') :
                            '' }}</td>
                        <td *ngIf="selectedCategory1Name.has('雨刮')">
                            <div *ngFor="let featureItem of filterFeature(item); let i = index">
                                <span *ngIf="featureItem.featureNameCn === '长度 1（英寸）' ||
                                            featureItem.featureNameCn === '长度 2（英寸）' ||
                                            featureItem.featureNameCn === '长度 1' ||
                                            featureItem.featureNameCn === '长度 2' ||
                                            featureItem.featureNameCn === '雨刮1长度' ||
                                            featureItem.featureNameCn === '雨刮2长度(仅套装)'">
                                    {{editFeatureNameCn(featureItem.featureNameCn,
                                    item.partNo)}}:{{Math.round(parseFloat(featureItem.featureValue))}}
                                </span>
                            </div>
                        </td>
                        <td *ngIf="activeTabIndex === 0">
                            <div *ngFor="let remark of item.remarkExternalList;">
                                <a *ngIf="hasVideoUrl(item.categoryName,remark)"
                                    (click)="openVideoModal(item.categoryName,remark)"
                                    style="cursor:pointer; color:#1890ff;">
                                    {{ getRemarks(remark, item.categoryName) }}
                                    <i nz-icon nzType="video-camera" nzTheme="outline"></i>
                                </a>
                                <span *ngIf="!isVideoModal(remark)">{{remark}}</span>
                            </div>
                        </td>
                        <!-- <td [nzRight]="'0px'">
                            <i nz-icon nzType="file-search" style="cursor: pointer; color: #007BC0;"
                                (click)="goDetail(item.partId)"></i>
                        </td> -->
                    </tr>
                </tbody>
            </nz-table>
            <ng-template #totalTemplate let-total>
                <span style="font-size: 16px; margin-right: 10px;">共{{pageInfo.totalCounts}}条</span>
            </ng-template>
        </div>
    </div>
</div>
